import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Snack, SnackButton } from '../styled-components/SnackBar';
import LuciPropTypes from '../propTypes';
import { actions as snackbarActions } from '../actions/snackbar';
import ButtonTemplates from '../constants/snackbarButtonTemplates';

class SnackBar extends Component {
  constructor() {
    super();
    this.state = {
      snack: null,
      visible: false
    };
  }

  componentDidMount() {
    if (this.props.snack) {
      this.showSnack(this.props.snack);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { snack } = this.props;
    const nextSnack = nextProps.snack;
    const visibleSnack = this.state.snack;

    if ((nextSnack && !snack) || (nextSnack && nextSnack.id !== (snack || {}).id)) {
      this.showSnack(nextSnack);
    } else if (snack && !visibleSnack) {
      this.showSnack(snack);
    } else if (!nextSnack && snack) {
      this.hideSnack();
    }
  }

  componentWillUnmount() {
    this.clearDismissTimer();
  }

  showSnack = nextSnack => {
    const snack = {
      ...nextSnack
    };
    if (snack.data.buttonTemplate) {
      //eslint-disable-next-line
      snack.data.button = this.constructButtonFromTemplate(snack);
    }
    this.hideSnack()
      .then(() => {
        this.setState({ snack, visible: false });
        setTimeout(() => {
          this.setState({ visible: true });
          if (snack.data.timeout || !snack.data.button) {
            this.snackTimer = setTimeout(
              () => this.props.dismissSnack(snack.id),
              snack.data.timeout || 7000
            );
          }
        }, 1);
        return Promise.resolve();
      })
      .catch(error => {
        console.log('Error showing snack');
        console.log(error);
      });
  };

  hideSnack = () => {
    if (!this.state.snack) {
      return Promise.resolve();
    }
    return new Promise(resolve => {
      this.clearDismissTimer();
      this.setState({ visible: false });
      this.afterTransition = () => {
        this.setState({ snack: null });
        resolve();
      };
    });
  };

  transitionEndHandler = () => {
    if (this.afterTransition) {
      this.afterTransition();
      this.afterTransition = null;
    }
  };

  constructButtonFromTemplate = snack => {
    switch (snack.data.buttonTemplate) {
      case ButtonTemplates.DISMISS:
        return {
          label: 'Dismiss',
          action: () => this.props.dismissSnack(snack.id)
        };
      default:
        return null;
    }
  };

  clearDismissTimer = () => {
    if (this.snackTimer) {
      clearTimeout(this.snackTimer);
      this.snackTimer = null;
    }
  };

  render() {
    const { snack, visible } = this.state;
    const content = snack ? snack.data.content : null;
    const button = snack ? snack.data.button : null;

    return (
      <Snack className={visible ? 'visible' : ''} onTransitionEnd={this.transitionEndHandler}>
        {content}
        {button && <SnackButton onClick={button.action}>{button.label}</SnackButton>}
      </Snack>
    );
  }
}

SnackBar.defaultProps = {
  snack: null
};

SnackBar.propTypes = {
  snack: LuciPropTypes.Snack,
  dismissSnack: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  snack: state.snackbar.snacks[0] || null // only show one snack at a time
});

const mapActionCreators = {
  dismissSnack: snackbarActions.dismissSnack
};

export default connect(mapStateToProps, mapActionCreators)(SnackBar);



// WEBPACK FOOTER //
// ./app/components/SnackBar.js